import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  locationIds: [],
  roomIds: [],
};

const scheduleSelectionSlice = createSlice({
  name: "schedule",
  initialState,
  reducers: {
    setSelectedLocations: (state, action) => {
      state.locationIds = action.payload;
    },
    setSelectedMeetingRooms: (state, action) => {
      state.roomIds = action.payload;
    },
    setScheduleLogout: (state, action) => {
      state.roomIds = [];
      state.locationIds = [];
    },
  },
});

export const {
  setSelectedLocations,
  setSelectedMeetingRooms,
  setScheduleLogout,
} = scheduleSelectionSlice.actions;
export default scheduleSelectionSlice.reducer;
